import { Component } from '@angular/core';
@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.html',
  styleUrl: '../legal-pages.scss',
})
export class LegalNotice {}
